"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../../../../../theme/styled-components"));
var useScript_1 = tslib_1.__importDefault(require("../../../../../view/hooks/useScript"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var scriptAttributes = {
    id: 'facebook-jssdk',
    src: 'https://connect.facebook.net/sk_SK/sdk.js',
    async: true,
    defer: true,
    crossOrigin: 'anonymous'
};
var FacebookWrapper = function (_a) {
    var config = _a.config, children = _a.children;
    var wrapperRef = React.useRef(null);
    React.useEffect(function () {
        if (!document.querySelector("#fb-init-script")) {
            var initScript = document.createElement('script');
            initScript.setAttribute('id', 'fb-init-script');
            initScript.appendChild(document.createTextNode("window.fbAsyncInit=function(){FB.init({xfbml:!0,version:\"v15.0\"})};"));
            document.body.appendChild(initScript);
        }
    }, []);
    React.useEffect(function () {
        var _a, _b;
        var wrapperEl = wrapperRef.current;
        if (wrapperEl) {
            try {
                (_b = (_a = window) === null || _a === void 0 ? void 0 : _a.FB) === null || _b === void 0 ? void 0 : _b.XFBML.parse(wrapperEl);
            }
            catch (e) {
                console.error(e); // tslint:disable-line:no-console
            }
        }
    }, [config]);
    useScript_1["default"](scriptAttributes);
    return React.createElement(Wrapper, { ref: wrapperRef }, children);
};
exports["default"] = FacebookWrapper;
var templateObject_1;
